import standardAPI from '@/api/standard_items';

const responseUrl = '/hotels/room-parameters';

const state = {
  room_parameters: [],
  room_parameters_MetaData: {},
  room_parameters_status: '',
  room_parameters_page: 1,
  room_parameters_perPage: 10,
};

const getters = {
  get_room_parameters: (state) => {
    return state.room_parameters;
  },
  get_room_parameters_status: (state) => {
    return state.room_parameters_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_room_parameters ({ commit }, getOptions) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_PARAMETERS_UPDATE_SUCCESS', response);
            commit('DATA_PARAMETERS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_PARAMETERS_READY');
            reject(response);
          } else {
            commit('DATA_PARAMETERS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_room_parameters_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_parameter ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  edit_parameter ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    console.log('itemData :',itemData)
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  remove_room_parameters ({ commit, dispatch }, itemData) {
    commit('DATA_PARAMETERS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_PARAMETERS_REQUEST');
          resolve();
        } else {
          commit('DATA_PARAMETERS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_parameter ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_parameter_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.room_parameters_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.room_parameters_perPage = max;
  },
  DATA_PARAMETERS_READY: (state) => {
    state.room_parameters_status = 'ready';
  },
  DATA_PARAMETERS_REQUEST: (state) => {
    state.room_parameters_status = 'loading';
  },
  DATA_PARAMETERS_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.room_parameters_MetaData.meta = response.meta;
      state.room_parameters_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.room_parameters = response.data || [];
    }
    state.room_parameters_status = 'success';
  },
  DATA_PARAMETERS_ERROR: (state) => {
    state.room_parameters_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
